import { Button, Modal } from '@lingxi-common-component/sirius-ui';
import React, { useRef, useState } from 'react';
import styles from './auth.module.scss';
import { apiHolder as api, getIn18Text, isElectron, conf as config, locationHelper } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { ReactComponent as ExclamationIcon } from '@web-edm/addressBook/assets/exclamation.svg';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
const systemApi = api.api.getSystemApi();
const isProd = config('stage') === 'prod';
const Auth = props => {
    const { authData, setAuthData } = props;
    const [step, setStep] = useState(1);
    const { mails } = useAppSelector(state => state.mailReducer);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const { tabList } = useAppSelector(state => state.mailTabReducer);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const currentTabIdRef = useRef(currentTabId);
    currentTabIdRef.current = currentTabId;
    const currentMailIdRef = useRef(currentMailId);
    currentMailIdRef.current = currentMailId;
    const dispatch = useAppDispatch();
    const openAuth = async () => {
        const host = isProd ? 'mail.qiye.163.com' : 'maildev.qiye.163.com';
        const { authPath } = authData;
        const url = `https://${host}${authPath}`;
        if (isElectron()) {
            const curWin = await window.electronLib.windowManage.getCurWindow();
            systemApi.openNewWindow(url, true, [{ observerWinId: curWin.id, hooksName: 'onWillNavigate', enable: true, intercept: false }], undefined, undefined, undefined, false);
        }
        else {
            console.log('开始校验', url);
            window.open(url);
        }
        setStep(2);
    };
    const cancel = () => {
        setAuthData(Object.assign(Object.assign({}, authData), { show: false, curSendId: '' }));
    };
    const auth = () => {
        openAuth();
    };
    const continueSend = () => {
        var _a;
        const { curSendId } = authData;
        if (locationHelper.testPathMatch('/writeMail') || curSendId === currentTabIdRef.current) {
            (_a = document.getElementById('sendValidateComp')) === null || _a === void 0 ? void 0 : _a.click();
            cancel();
        }
        else {
            if (mails.find(mail => mail.cid === curSendId) && tabList.find(tab => tab.id === curSendId)) {
                dispatch(mailTabActions.doChangeCurrentTab(curSendId));
                currentMailIdRef.current !== curSendId && dispatch(mailActions.doChangeCurrentMail(curSendId));
                setTimeout(() => {
                    var _a;
                    if (currentTabIdRef.current === curSendId && currentMailIdRef.current === curSendId) {
                        (_a = document.getElementById('sendValidateComp')) === null || _a === void 0 ? void 0 : _a.click();
                    }
                    else {
                        SiriusMessage.error(getIn18Text('FASONGSHIBAI'));
                    }
                    cancel();
                }, 200);
            }
        }
        setAuthData(Object.assign(Object.assign({}, authData), { show: false, curSendId: '' }));
    };
    return (React.createElement(Modal, { className: styles.authModal, width: 400, visible: authData === null || authData === void 0 ? void 0 : authData.show, destroyOnClose: true, footer: null, onCancel: cancel },
        step === 1 && (React.createElement("div", { className: styles.modalCont },
            React.createElement("div", { className: styles.headr },
                React.createElement("div", { className: classnames(styles.icon, styles.red) },
                    React.createElement(ExclamationIcon, null)),
                getIn18Text('FAXINBEIJUJUE')),
            React.createElement("div", { className: styles.cont },
                React.createElement("p", null, getIn18Text('XITONGJIANCEDAOYOUJIAN')),
                React.createElement("p", { className: styles.line2 }, getIn18Text('JIANCEDAOYXKNCZFXQJX12'))),
            React.createElement("div", { className: styles.footer },
                React.createElement(Button, { onClick: cancel }, getIn18Text('setting_system_switch_cancel')),
                React.createElement(Button, { className: styles.blue, onClick: auth }, getIn18Text('SHENFENYANZ'))))),
        step === 2 && (React.createElement("div", { className: styles.modalCont },
            React.createElement("div", { className: styles.headr },
                React.createElement("div", { className: styles.icon },
                    React.createElement(ExclamationIcon, null)),
                getIn18Text('SHIFOUYIWCSFYZ')),
            React.createElement("div", { className: styles.footer },
                React.createElement(Button, { onClick: cancel }, getIn18Text('setting_system_switch_cancel')),
                React.createElement(Button, { className: styles.blue, onClick: continueSend }, getIn18Text('WOYIWANCJXFS')))))));
};
export default Auth;
